// Module
var code = "<button type=\"button\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-primary': SearchCtrl.filters.top[field]}\" ng-click=\"onSelect()\"> <i class=\"fa\" ng-class=\"{'fa-check-square-o': SearchCtrl.filters.top[field], 'fa-square-o': !SearchCtrl.filters.top[field]}\"></i> {{label}} </button>";
// Exports
module.exports = code;